module.exports = __webpack_public_path__ + "img/viewpoint-left-icon.752bc853.png";